export const XCARD_STATUS_ORDERED = 'ORDERED';
export const XCARD_STATUS_ACTIVE = 'ACTIVE';
export const XCARD_STATUS_DISABLED = 'DISABLED';

export const XCARD_GENDER__FEMALE = 'F';
export const XCARD_GENDER__MALE = 'M';

export const xcardGenders = [
  XCARD_GENDER__FEMALE,
  XCARD_GENDER__MALE,
];

export const xcardGenderLangKeys = {
  [XCARD_GENDER__FEMALE]: 'msg.xcard.gender.female',
  [XCARD_GENDER__MALE]: 'msg.xcard.gender.male',
};
